module.exports = __webpack_public_path__ + "media/images/banners/banners-610152efe6a0b6f551fac499d2db58c7.jpg";